module.exports = __webpack_public_path__ + "static/media/user-default.f6441015.png";